import { EnumFileType } from '@libs/constants';
import { Validator, ValidatorSchema } from '@libs/utilities/validator';

import { EnumPodImageColor, EnumPodImageColorType } from './print-on-demand.constants';


/**------------------------------------------------------
 * Image Data
 */
export interface IPodImage {
	flyId			: string;
	mimeType		: EnumFileType;
	fileName		: string;
	imgUrl          : IImageUrl;
	resolution      : IImageResolution;
	colors          : IImageColors;
	pHash			: string;
	createdAt	    : Date;
	updatedAt	    : Date;
	aiMetaInfo		: IAiMetaInfo | null;
}


/**------------------------------------------------------
 * Divided Parts of the Interface
 */
export interface IImageUrl {
	icon	    	: string;
	preview	    	: string;
	original    	: string;
}

export interface IImageResolution {
	width       	: number;
	height      	: number;
}

export interface IImageColors {
	dominant    	: EnumPodImageColor;
	avg         	: string;
	colorType   	: EnumPodImageColorType;
	colorList		: IListColor[];
}

export interface IListColor {
	name			: EnumPodImageColor;
	percentage		: number;
}

export interface IAiMetaInfo {
	prompt			: string;
	aiModel     	: string;
}


/**------------------------------------------------------
 * Schema Validator
 */
export class ImageResolutionSchema implements ValidatorSchema<IImageResolution> {
	width       = Validator.Number().isPositive();
	height      = Validator.Number().isPositive();
}
